export default {
  'pages:subscription-confirmation:page-title': 'Confirm registration',
  'pages:subscription-confirmation:header': 'Please wait a moment...',
};
